"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContainer = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = __importDefault(require("../../theme"));
var moveKeyFrame = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  0%   { transform: scale(1)   translate(10px, -30px); }\n  38%  { transform: scale(0.8, 1) translate(80vw, 30vh) rotate(160deg); }\n  40%  { transform: scale(0.8, 1) translate(80vw, 30vh) rotate(160deg); }\n  78%  { transform: scale(1.3) translate(0vw, 50vh) rotate(-20deg); }\n  80%  { transform: scale(1.3) translate(0vw, 50vh) rotate(-20deg); }\n  100% { transform: scale(1)   translate(10px, -20px); }\n"], ["\n  0%   { transform: scale(1)   translate(10px, -30px); }\n  38%  { transform: scale(0.8, 1) translate(80vw, 30vh) rotate(160deg); }\n  40%  { transform: scale(0.8, 1) translate(80vw, 30vh) rotate(160deg); }\n  78%  { transform: scale(1.3) translate(0vw, 50vh) rotate(-20deg); }\n  80%  { transform: scale(1.3) translate(0vw, 50vh) rotate(-20deg); }\n  100% { transform: scale(1)   translate(10px, -20px); }\n"])));
var MainContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  fill: ", ";\n  width: 50vmax;\n  animation: ", " 10s ease-in-out infinite;\n  transform-origin: 30% 30%;\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  fill: ", ";\n  width: 50vmax;\n  animation: ", " 10s ease-in-out infinite;\n  transform-origin: 30% 30%;\n"])), function (_a) {
    var color = _a.color;
    return color || theme_1.default.colorsPalette.blue.default;
}, moveKeyFrame);
exports.MainContainer = MainContainer;
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map